import { appAnnotationIcon } from './annotation';
import { appMail01Icon } from './mail-01';
import { appMail04Icon } from './mail-04';
import { appPhoneIcon } from './phone';
export const communicationIcons = [appAnnotationIcon, appMail01Icon, appMail04Icon, appPhoneIcon];
